import { render, staticRenderFns } from "./EdgeToggle.vue?vue&type=template&id=20d365d9&scoped=true&lang=pug"
import script from "./EdgeToggle.vue?vue&type=script&lang=js"
export * from "./EdgeToggle.vue?vue&type=script&lang=js"
import style0 from "./EdgeToggle.vue?vue&type=style&index=0&id=20d365d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d365d9",
  null
  
)

export default component.exports